import clsx from 'clsx';
import { FunctionComponent } from 'react';
import UnitName from './UnitName';
import styles from './UnitNames.module.scss';
import { RoomUnit } from '@spike/room-model';
import { Label } from 'components/UI/V3/Forms/Label/Label';

interface UnitNamesProps {
    isEdit?: boolean;
    units: Array<RoomUnit>;
    className?: string;
    onChange?: (units: Array<RoomUnit>) => void;
}

export const UnitNames: FunctionComponent<UnitNamesProps> = props => {
    const changeHandler = (updatedUnit: RoomUnit) => {
        props.onChange?.(props.units.map(unit => (unit.uuid === updatedUnit.uuid ? updatedUnit : unit)));
    };

    const removeHandler = (removedUnit: RoomUnit) => {
        if (removedUnit.id) {
            props.onChange?.(
                props.units.map(unit => (unit.uuid === removedUnit.uuid ? { ...unit, destroy: true } : unit))
            );
        } else {
            props.onChange?.(props.units.filter(unit => unit.uuid !== removedUnit.uuid));
        }
    };

    return (
        <div className={clsx(styles.container, props.className)}>
            <div className={styles.unitNameContainer}>
                {props.isEdit && <Label className={styles.availableLabel}>Available</Label>}
                <Label>Name</Label>
            </div>
            {props.units.map((unit, index) => (
                <UnitName
                    key={unit.uuid}
                    unit={unit}
                    isEdit={props.isEdit}
                    removable={index > 0}
                    onChange={changeHandler}
                    onRemove={() => removeHandler(unit)}
                />
            ))}
        </div>
    );
};

export default UnitNames;
